import AppBaseStore from './baseStore'
import { useDjango } from '@/composables/useDjango'
import API from '@/api/apiUrls'
import { defineStore } from 'pinia'

const { api } = useDjango()

export interface SpeckleIntegration {
  id: number
  project_id: string
  linked_model: number
}

const baseUrl = API.SPECKLE.BASE
const baseStore = new AppBaseStore(baseUrl, api)

export const useSpeckleIntegrationStore = defineStore('speckleIntegration', {
  state: () => ({
    ...baseStore.state
  }),
  actions: {
    ...baseStore.actions
  },
  getters: {
    ...baseStore.getters
  }
})
